"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _valuePropValidation = _interopRequireDefault(require("./helpers/valuePropValidation"));

var _getNormalizedValue = _interopRequireDefault(require("./helpers/getNormalizedValue"));

var _hooks = require("../../libs/hooks");

var _useReduxForm2 = _interopRequireDefault(require("../../libs/hooks/useReduxForm"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _label = _interopRequireDefault(require("../Input/label"));

var _weekDayItems = _interopRequireDefault(require("./weekDayItems"));

var _errorText = _interopRequireDefault(require("../Input/styled/errorText"));

var _styled = require("./styled");
/* eslint-disable react/no-unused-prop-types */

/**
 * A WeekDayPicker allows to select the days of the week
 * @category Form
 */


var WeekDayPicker = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useReduxForm = (0, _useReduxForm2["default"])(props),
      id = _useReduxForm.id,
      name = _useReduxForm.name,
      value = _useReduxForm.value,
      label = _useReduxForm.label,
      labelAlignment = _useReduxForm.labelAlignment,
      hideLabel = _useReduxForm.hideLabel,
      bottomHelpText = _useReduxForm.bottomHelpText,
      availableDates = _useReduxForm.availableDates,
      localeProp = _useReduxForm.locale,
      disabled = _useReduxForm.disabled,
      required = _useReduxForm.required,
      readOnly = _useReduxForm.readOnly,
      multiple = _useReduxForm.multiple,
      error = _useReduxForm.error,
      onChange = _useReduxForm.onChange,
      className = _useReduxForm.className,
      style = _useReduxForm.style;

  var locale = (0, _hooks.useLocale)(localeProp);
  var defaultFieldsetName = (0, _hooks.useUniqueIdentifier)('week-day-items');
  var fieldsetName = name || defaultFieldsetName;
  var inputRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        inputRef.current.focus();
      },
      click: function click() {
        inputRef.current.click();
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    };
  });

  var handleOnChange = function handleOnChange(event) {
    var weekDayValue = event.target.value;
    var isChecked = event.target.checked;

    if (!disabled && !readOnly) {
      onChange((0, _getNormalizedValue["default"])(weekDayValue, isChecked, multiple, value));
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_styled.StyledFieldset, {
    className: className,
    style: style,
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: label
  }, /*#__PURE__*/_react["default"].createElement(_label["default"], {
    label: label,
    labelAlignment: labelAlignment,
    hideLabel: hideLabel,
    required: required,
    as: "legend"
  })), /*#__PURE__*/_react["default"].createElement(_weekDayItems["default"], {
    name: fieldsetName,
    value: value,
    availableDates: availableDates,
    locale: locale,
    disabled: disabled,
    required: required,
    readOnly: readOnly,
    multiple: multiple,
    error: error,
    onChange: handleOnChange,
    ref: inputRef
  }), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: bottomHelpText
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledHelpText, null, bottomHelpText)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: error
  }, /*#__PURE__*/_react["default"].createElement(_errorText["default"], null, error)));
});

WeekDayPicker.propTypes = {
  /** The id of the outer element. */
  id: _propTypes["default"].string,

  /** An identifier for the group of radio items. */
  name: _propTypes["default"].string,

  /** The value of WeekDayPicker, a list of days selected. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_valuePropValidation["default"]), _propTypes["default"].oneOf(['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'])]),

  /** The WeekDayPicker label. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Describes the position of the WeekDayPicker label. Options include left, center and right.
   * This value defaults to center. */
  labelAlignment: _propTypes["default"].oneOf(['left', 'center', 'right']),

  /** A boolean to hide the WeekDayPicker label. */
  hideLabel: _propTypes["default"].bool,

  /** Shows the help message below the WeekDayPicker */
  bottomHelpText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies the available days from the week for selection. */
  availableDates: _propTypes["default"].arrayOf(_valuePropValidation["default"]),

  /** The WeekDayPicker locale. Defaults to browser's language. */
  locale: _propTypes["default"].string,

  /** Specifies that the WeekDayPicker element should be disabled. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** Specifies that the WeekDayPicker field must be filled before submitting the form. */
  required: _propTypes["default"].bool,

  /** Specifies that the WeekDayPicker is read-only. */
  readOnly: _propTypes["default"].bool,

  /** Specifies that the WeekDayPicker can have more than one selected option. */
  multiple: _propTypes["default"].bool,

  /** Specifies that the WeekDayPicker must be filled out before submitting the form. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The action triggered when a value attribute changes. */
  onChange: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
WeekDayPicker.defaultProps = {
  id: undefined,
  name: undefined,
  value: undefined,
  label: undefined,
  labelAlignment: 'center',
  hideLabel: false,
  bottomHelpText: undefined,
  availableDates: [],
  locale: undefined,
  disabled: false,
  required: false,
  readOnly: false,
  multiple: false,
  error: null,
  onChange: function onChange() {},
  className: undefined,
  style: undefined
};
var _default = WeekDayPicker;
exports["default"] = _default;